import { ProcessTableProvider, signalsListLocalStorageKey, useProcessesForTable } from "../../context/ProcessTableContext";
import { ProcessTablePage } from "./ProcessTablePage";
import { ProcessFilterZod } from "@avenueops/shared-types";
import { ArchivedFilter } from "@avenueops/shared-types/src";
import { ProcessView } from "@prisma/client";
import { BulkActionsProvider } from "context/BulkActionsContext";
import React, { useMemo } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

interface Props {
  signalViewId?: string;
  signalView?: ProcessView;
  starterFilters?: ProcessFilterZod[];
  archived: ArchivedFilter;
  isDashboard: boolean;
}

// TODO: Rename both `ProcessTablePageWrapper` and `ProcessTablePage`. Not sure what to call them yet.
export default function ProcessTablePageWrapper({ signalViewId, signalView, starterFilters, archived, isDashboard }: Props): JSX.Element {
  return (
    <DndProvider backend={HTML5Backend}>
      <ProcessTableProvider starterFilters={starterFilters} localStorageKey={signalsListLocalStorageKey} signalView={signalView} archived={archived}>
        <ProcessTableBulkActionsWrapper
          signalViewId={signalViewId}
          signalView={signalView}
          starterFilters={starterFilters}
          archived={archived}
          isDashboard={isDashboard}
        />
      </ProcessTableProvider>
    </DndProvider>
  );
}

function ProcessTableBulkActionsWrapper({ signalViewId, signalView, starterFilters, archived, isDashboard }: Props): JSX.Element {
  const { filteredProcessGroups } = useProcessesForTable({ archived, isDashboard });
  const itemIds = useMemo(() => filteredProcessGroups.flatMap((group) => group.processes.map((process) => process.id)), [filteredProcessGroups]);
  return (
    <BulkActionsProvider itemIds={new Set(itemIds)}>
      <div key={signalViewId}>
        <ProcessTablePage signalView={signalView} archived={archived} isDashboard={isDashboard} />
      </div>
    </BulkActionsProvider>
  );
}
